import React from 'react';
import PanelHelpBadge from '../PanelHelpBadge';

const SEGMENT_OPTIONS = [
  { value: 'bebekli', label: 'Bebekli' },
  { value: 'alerjanli', label: 'Alerjanlı' },
  { value: 'premium', label: 'Premium' },
  { value: 'uzmanli', label: 'Uzmanlı' },
  { value: 'yogun-calisan', label: 'Yoğun Çalışan' },
  { value: 'ev-hanimi', label: 'Ev Hanımı' },
  { value: 'ogrenci', label: 'Öğrenci' },
  { value: 'emekli', label: 'Emekli' }
];

export default function DashboardQuickFilterBar({ selectedSegment, onSelectSegment }) {
  return (
    <section className="min-h-14 rounded-xl border border-slate-200 bg-white px-3 py-2 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <div className="flex items-center gap-2">
        <p className="text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">Hızlı Segmentler</p>
        <PanelHelpBadge
          title="Hızlı Segmentler"
          description="Segment filtrelerini tek dokunuşla açıp ana kartları o profile göre okuyabilirsin."
          interpretation="Önce segment seç, sonra kartlardan Detaya git ile drill-down başlat."
          metricExample="Aynı metrik farklı segmentte belirgin ayrışıyorsa segment bazlı aksiyon gerekir."
        />
      </div>

      <div className="mt-2 flex items-center gap-2 overflow-x-auto pb-1">
        {SEGMENT_OPTIONS.map((segment) => {
          const active = selectedSegment === segment.value;
          return (
            <button
              key={segment.value}
              type="button"
              onClick={() => onSelectSegment(active ? '' : segment.value)}
              className={`shrink-0 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${active
                ? 'border-primary bg-primary text-white'
                : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800'
              }`}
            >
              {segment.label}
            </button>
          );
        })}

        <button
          type="button"
          onClick={() => onSelectSegment('')}
          className="shrink-0 rounded-full border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-500 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-800"
        >
          Temizle
        </button>
      </div>
    </section>
  );
}
